import { getColor, stringToBoolean, safeJsonParse } from "../index";
import {
  DefaultHeading,
  DefaultForm,
  CustomImage,
  CustomCollapsible,
  MeatBallsLoader,
  StepCard,
  QueueCard,
  DetailCard,
  ProgressCircleChart,
  TabBar,
  EligibilityCards,
  NafathCodeBanner,
  CustomOTPInput,
  PhoneNumberInput,
  SliderCard,
  LoanProgressCard,
  OnboardingCard,
  LoanDetailsCard,
  LoanDisbursementCard,
  BankSelectCard,
  CustomConnectCard,
  IconText,
  CustomContentCard,
  BulletCard,
  UploadCard,
  PoweredByLogo,
  RequestIdCard,
  UploadDocSuccessCard,
  StatusInfoCard,
  BankConnectCard,
  DataLabelCard,
  PingPongIcons,
  RequiredDocumentsCard,
  FileUploadCard,
  PartnerListCard,
  CurrentLinkedBankCard,
  SelectedBankBadge,
  PaymentScheduleCard,
  DocumentUploadCard,
  ErrorImage,
  StepperSection,
  SelectableItemCard,
  InfoKeyValueCard,
  PaymentMethodCard,
  RequeiredDocumentList,
  DatePickerInput,
  NoticeCard,
  DownloadDocumentCard,
  DocumentGroupUploadCard,
  HeadingSkeleton,
  DetailCardSkeleton,
  NoticeCardSkeleton,
  ButtonSkeleton,
  HowItWorksCards,
  AvailableAssetsCard,
  RadioGroup,
  EditOptionCard,
} from "../../components";
import { BODY_TYPES, FOOTER_TYPES } from "../../constants";
import { getPngImages, getSvgComponent } from "../svgUtils";

//body component mapping
export const BODY_COMPONENT_MAPPING = {
  [BODY_TYPES.HEADING]: (props) => <DefaultHeading {...props} />,
  [BODY_TYPES.FORM]: (props) => <DefaultForm {...props} />,
  [BODY_TYPES.IMAGE]: (props) => <CustomImage {...props} />,
  [BODY_TYPES.VERIFY_STATUS]: (props) => <NafathCodeBanner {...props} />,
  [BODY_TYPES.INFO_CARD]: (props) => (
    <CustomCollapsible {...props}>
      {props?.collapsibleCildren}
    </CustomCollapsible>
  ),
  [BODY_TYPES.DETAIL_CARD]: (props) => <DetailCard {...props} />,
  [BODY_TYPES.STEP_CARD]: (props) => <StepCard {...props} />,
  [BODY_TYPES.QUEUE_CARD]: (props) => <QueueCard {...props} />,
  [BODY_TYPES.PROGRESS_CIRCLE_CHART]: (props) => (
    <ProgressCircleChart {...props} />
  ),
  [BODY_TYPES.TAB_BAR]: (props) => <TabBar {...props} />,
  [BODY_TYPES.ELIGIBILITY_CARDS]: (props) => <EligibilityCards {...props} />,
  [BODY_TYPES.OTP_INPUT]: (props) => <CustomOTPInput {...props} />,
  [BODY_TYPES.PHONE_NUMBER_INPUT]: (props) => <PhoneNumberInput {...props} />,
  [BODY_TYPES.SLIDER_CARD]: (props) => <SliderCard {...props} />,
  [BODY_TYPES.LOAN_PROGRESS_CARD]: (props) => <LoanProgressCard {...props} />,
  [BODY_TYPES.LOAN_DETAILS_CARD]: (props) => <LoanDetailsCard {...props} />,
  [BODY_TYPES.MEAT_BALLS_LOADER]: (props) => <MeatBallsLoader {...props} />,
  [BODY_TYPES.ONBOARDING_CARD]: (props) => <OnboardingCard {...props} />,
  [BODY_TYPES.LOAN_DISBURSEMENT_CARD]: (props) => (
    <LoanDisbursementCard {...props} />
  ),
  [BODY_TYPES.CONTENT_HEADING]: (props) => (
    <span className="content-heaing">{props?.heading}</span>
  ),
  [BODY_TYPES.BANK_SELECT_CARD]: (props) => <BankSelectCard {...props} />,
  [BODY_TYPES.CUSTOM_CONNECT_CARD]: (props) => <CustomConnectCard {...props} />,
  [BODY_TYPES.CUSTOM_CONTENT_CARD]: (props) => (
    <CustomContentCard {...props}>{props?.cardContent}</CustomContentCard>
  ),
  [BODY_TYPES.BULLET_CARD]: (props) => <BulletCard {...props} />,
  [BODY_TYPES.UPLOAD_CARD]: (props) => <UploadCard {...props} />,
  [FOOTER_TYPES.ICON_TEXT]: (props) => <IconText {...props} />,
  [BODY_TYPES.REQUEST_ID_CARD]: (props) => <RequestIdCard {...props} />,
  [BODY_TYPES.POWERED_BY]: (props) => <PoweredByLogo {...props} />,
  [BODY_TYPES.UPLOAD_SUCCESS_CARD]: (props) => (
    <UploadDocSuccessCard {...props} />
  ),
  [BODY_TYPES.STATUS_INFO_CARD]: (props) => <StatusInfoCard {...props} />,
  [BODY_TYPES.CONNECT_BANK_CARD]: (props) => <BankConnectCard {...props} />,
  [BODY_TYPES.COLLAPSIBLE_INFO]: (props) => (
    <CustomCollapsible {...props}>
      {props?.collapsibleCildren}
    </CustomCollapsible>
  ),
  [BODY_TYPES.DATA_LABEL_CARD]: (props) => <DataLabelCard {...props} />,
  [BODY_TYPES.PING_PONG_ICONS]: (props) => <PingPongIcons {...props} />,
  [BODY_TYPES.REQUIRED_DOCUMENTS_CARD]: (props) => (
    <RequiredDocumentsCard {...props} />
  ),
  [BODY_TYPES.FILE_UPLOAD_CARD]: (props) => <FileUploadCard {...props} />,
  [BODY_TYPES.PARTNER_LIST_CARD]: (props) => <PartnerListCard {...props} />,
  [BODY_TYPES.CURRENT_LINKED_BANK_CARD]: (props) => (
    <CurrentLinkedBankCard {...props} />
  ),
  [BODY_TYPES.SELECTED_BANK_BADGE]: (props) => <SelectedBankBadge {...props} />,
  [BODY_TYPES.PAYMENT_SCHEDULE_CARD]: (props) => (
    <PaymentScheduleCard {...props} />
  ),
  [BODY_TYPES.DOCUMENT_UPLOAD_CARD]: (props) => (
    <DocumentUploadCard {...props} />
  ),
  [BODY_TYPES.EXCLAMATION_ERROR_IMAGE]: (props) => <ErrorImage {...props} />,
  [BODY_TYPES.STEPPER_SECTION]: (props) => <StepperSection {...props} />,
  [BODY_TYPES.SELECTABLE_ITEM_CARD]: (props) => (
    <SelectableItemCard {...props} />
  ),
  [BODY_TYPES.INFO_KEY_VALUE_CARD]: (props) => <InfoKeyValueCard {...props} />,
  [BODY_TYPES.PAYMENT_METHOD_CARD]: (props) => <PaymentMethodCard {...props} />,
  [BODY_TYPES.REQUIRED_LIST_DOCUMENT_CARD]: (props) => (
    <RequeiredDocumentList {...props} />
  ),
  [BODY_TYPES.DATE_PICKER_INPUT]: (props) => <DatePickerInput {...props} />,
  [BODY_TYPES.NOTICE_CARD]: (props) => <NoticeCard {...props} />,
  [BODY_TYPES.DOWNLOAD_DOCUMENT_CARD]: (props) => (
    <DownloadDocumentCard {...props} />
  ),
  [BODY_TYPES.DOCUMENT_GROUP_UPLOAD_CARD]: (props) => (
    <DocumentGroupUploadCard {...props} />
  ),
  [BODY_TYPES.HEADING_SKELETON]: (props) => <HeadingSkeleton {...props} />,
  [BODY_TYPES.DETAIL_CARD_SKELETON]: (props) => (
    <DetailCardSkeleton {...props} />
  ),
  [BODY_TYPES.NOTICE_CARD_SKELETON]: (props) => (
    <NoticeCardSkeleton {...props} />
  ),
  [BODY_TYPES.BUTTON_SKELETON]: (props) => <ButtonSkeleton {...props} />,
  [BODY_TYPES.HOW_IT_WORKS_CARDS]: (props) => <HowItWorksCards {...props} />,
  [BODY_TYPES.AVAILABLE_ASSETS_CARD]: (props) => (
    <AvailableAssetsCard {...props} />
  ),
  [BODY_TYPES.RADIO_GROUP]: (props) => <RadioGroup {...props} />,
  [BODY_TYPES.EDIT_OPTION_CARD]: (props) => <EditOptionCard {...props} />,
};

export const bodySchema = (components, mapping) => {
  return components
    .map((item) => {
      switch (item.attributes.type) {
        // Used only to set initial form state
        case BODY_TYPES.INITIAL_FORM_STATE: {
          return {
            props: {
              type: BODY_TYPES.INITIAL_FORM_STATE,
              data: safeJsonParse(item?.attributes?.data, {}),
            },
          };
        }
        case BODY_TYPES.HEADING: {
          return {
            Component: mapping[BODY_TYPES.HEADING],
            props: {
              heading: item.attributes.heading,
              description: item.attributes.description,
              type: BODY_TYPES.HEADING,
              style: {
                headingFontSize: item?.attributes?.headingFontSize,
                descriptionFontSize: item?.attributes?.descriptionFontSize,
                centerAlign: item?.attributes?.center_align
                  ? item?.attributes?.center_align
                  : item?.attributes?.centerAlign,
                marginTop: item?.attributes?.marginTop,
                backgroundColor: item?.attributes?.backgroundColor,
                marginBottom: item?.attributes?.marginBottom,
                color: item?.attributes?.color,
              },
              leftIcon: getSvgComponent(item?.attributes?.leftIcon),
              descriptionLeftIcon: getSvgComponent(
                item?.attributes?.descriptionLeftIcon
              ),
              highgLightBtnAmount: item?.attributes?.highgLightBtnAmount,
              expiresIn: item?.attributes?.expiryDate,
              amount: item?.attributes?.amount
                ? JSON.parse(item?.attributes?.amount)
                : null,
              descriptionData: item?.attributes?.descriptionData,
              hasSpinner: item?.attributes?.hasSpinner,
              specialText: item?.attributes?.specialText,
              headingStyle: safeJsonParse(item?.attributes?.headingStyle, {}),
              specialTextStyle: safeJsonParse(
                item?.attributes?.specialTextStyle,
                {}
              ),
              descriptionStyle: safeJsonParse(
                item?.attributes?.descriptionStyle,
                {}
              ),
              iconVariant: item?.attributes?.iconVariant,
              iconColor: item?.attributes?.iconColor,
              rightIconContainerStyle: safeJsonParse(
                item?.attributes?.rightIconContainerStyle,
                {}
              ),
              highgLightBtnAmountStyle: safeJsonParse(
                item?.attributes?.highgLightBtnAmountStyle,
                {}
              ),
            },
          };
        }
        case BODY_TYPES.FORM:
          return {
            Component: mapping[BODY_TYPES.FORM],
            props: {
              components: item.components,
              type: BODY_TYPES.FORM,
            },
          };
        case BODY_TYPES.IMAGE: {
          return {
            Component:
              item?.attributes?.secondaryType === BODY_TYPES.VERIFY_STATUS
                ? mapping[BODY_TYPES.VERIFY_STATUS]
                : mapping[BODY_TYPES.IMAGE],
            props: {
              type: BODY_TYPES.IMAGE,
              isUrl: item?.attributes?.isUrl,
              isCampaignSvg: item?.attributes?.isCampaignSvg,
              image:
                item?.attributes?.isUrl || item?.attributes?.isCampaignSvg
                  ? item?.attributes?.image
                  : getPngImages(item?.attributes?.image),
              bankImage: item?.attributes?.bankImage,
              code: item?.attributes?.code,
              styles: {
                marginTop: item?.attributes?.marginTop
                  ? `${item?.attributes?.marginTop}px`
                  : `0px`,
                marginBottom: item?.attributes?.marginBottom
                  ? `${item?.attributes?.marginBottom}px`
                  : `0px`,
                width: item?.attributes?.width
                  ? `${item?.attributes?.width}px`
                  : `100%`,
                height: item?.attributes?.height
                  ? `${item?.attributes?.height}px`
                  : `auto`,
                alignSelf: item?.attributes?.alignSelf
                  ? `${item?.attributes?.alignSelf}`
                  : `none`,
              },
              imageName: item?.attributes?.image,
            },
          };
        }
        case BODY_TYPES.INFO_CARD:
          return {
            Component: mapping[BODY_TYPES.INFO_CARD],
            props: {
              type: BODY_TYPES.INFO_CARD,
              heading: item?.attributes?.heading,
              cardData: item?.attributes?.cardData,
              open: item?.attributes?.open,
              isCustomData: item?.attributes?.isCustomData,
              noteHeading: item?.attributes?.noteHeading,
              noteDescription: item?.attributes?.noteDescription,
              noteIcon: getSvgComponent(item?.attributes?.noteIcon),
              noteBackgroundColor: item?.attributes?.noteBackgroundColor,
              hasOtherInfoCard: item?.attributes?.hasOtherInfoCard,
              otherInfoCardData: safeJsonParse(
                item?.attributes?.otherInfoCardData
              ),
              hiddenValues: safeJsonParse(item?.attributes?.hiddenValues, []),
            },
          };
        case BODY_TYPES.STEP_CARD:
          return {
            Component: mapping[BODY_TYPES.STEP_CARD],
            props: {
              type: BODY_TYPES.STEP_CARD,
              cardHeading: item?.attributes?.heading,
              cardDescription: item?.attributes?.description,
              step: item?.attributes?.step,
              isActive: stringToBoolean(item?.attributes?.isActive),
            },
          };
        case BODY_TYPES.QUEUE_CARD:
          return {
            Component: mapping[BODY_TYPES.QUEUE_CARD],
            props: {
              type: BODY_TYPES.QUEUE_CARD,
              cardText: item.attributes.cardText,
              cardValue: item?.attributes?.cardValue,
            },
          };
        case BODY_TYPES.DETAIL_CARD:
          return {
            Component: mapping[BODY_TYPES.DETAIL_CARD],
            props: {
              type: BODY_TYPES.DETAIL_CARD,
              heading: item?.attributes?.heading,
              cardData: item?.attributes.cardData,
              isCustomData: item?.attributes?.isCustomData,
              attributes: item?.attributes,
            },
          };
        case BODY_TYPES.PROGRESS_CIRCLE_CHART:
          return {
            Component: mapping[BODY_TYPES.PROGRESS_CIRCLE_CHART],
            props: {
              type: BODY_TYPES.PROGRESS_CIRCLE_CHART,
            },
          };
        case BODY_TYPES.TAB_BAR:
          return {
            Component: mapping[BODY_TYPES.TAB_BAR],
            props: {
              type: BODY_TYPES.TAB_BAR,
              tabData: item?.attributes?.tabData,
              tabHeading: item?.attributes?.tabHeading,
            },
          };
        case BODY_TYPES.ELIGIBILITY_CARDS:
          return {
            Component: mapping[BODY_TYPES.ELIGIBILITY_CARDS],
            props: {
              type: BODY_TYPES.ELIGIBILITY_CARDS,
            },
          };
        case BODY_TYPES.OTP_INPUT:
          return {
            Component: mapping[BODY_TYPES.OTP_INPUT],
            props: {
              type: BODY_TYPES.OTP_INPUT,
              otpNotRecieve: item?.attributes?.otpNotRecieve,
              resendCode: item?.attributes?.resendCode,
              resend: item?.attributes?.resend,
              otpLength: item?.attributes?.otpLength,
            },
          };
        case BODY_TYPES.PHONE_NUMBER_INPUT:
          return {
            Component: mapping[BODY_TYPES.PHONE_NUMBER_INPUT],
            props: {
              type: BODY_TYPES.PHONE_NUMBER_INPUT,
            },
          };
        case BODY_TYPES.SLIDER_CARD:
          return {
            Component: mapping[BODY_TYPES.SLIDER_CARD],
            props: {
              type: BODY_TYPES.SLIDER_CARD,
              cardHeading: item?.attributes?.cardHeading,
              valueSuffix: item?.attributes?.valueSuffix,
              minValue: item?.attributes?.minValue,
              maxValue: item?.attributes?.maxValue,
              initialValue: item?.attributes?.initialValue,
              labelSuffix: item?.attributes?.labelSuffix,
              key: item?.attributes?.key,
              step: item?.attributes?.step,
              sliderHide: item?.attributes?.sliderHide,
              rightLabelData: item?.attributes?.rightLabelData,
              hasCalculatedValue: stringToBoolean(
                item?.attributes?.hasCalculatedValue
              ),
              isCustomValue: stringToBoolean(item?.attributes?.isCustomValue),
              cardDescription: item?.attributes?.cardDescription,
              noteIcon: getSvgComponent(item?.attributes?.noteIcon),
              noteHeading: item?.attributes?.noteHeading,
              noteDescription: item?.attributes?.noteDescription,
              noteBackgroundColor: item?.attributes?.noteBackgroundColor,
              hasFloatingTag: stringToBoolean(item?.attributes?.hasFloatingTag),
              tagSuffix: item?.attributes?.tagSuffix,
              hasCustomValue: stringToBoolean(item?.attributes?.hasCustomValue),
              cardSubHeading: item?.attributes?.cardSubHeading,
              hasOtherInfoCard: item?.attributes?.hasOtherInfoCard,
              otherInfoCardHeading: item?.attributes?.otherInfoCardHeading,
              infoValueSubtext: item?.attributes?.infoValueSubtext,
            },
          };
        case BODY_TYPES.CONTENT_HEADING:
          return {
            Component: mapping[BODY_TYPES.CONTENT_HEADING],
            props: {
              type: BODY_TYPES.CONTENT_HEADING,
              heading: item?.attributes?.heading,
            },
          };
        case BODY_TYPES.LOAN_PROGRESS_CARD:
          return {
            Component: mapping[BODY_TYPES.LOAN_PROGRESS_CARD],
            props: {
              type: BODY_TYPES.LOAN_PROGRESS_CARD,
              percentage: item?.attributes?.percentage,
              currentStep: item?.attributes?.currentStep,
              totalStep: item?.attributes?.totalStep,
              stepHeading: item?.attributes?.stepHeading,
            },
          };
        case BODY_TYPES.LOAN_DETAILS_CARD:
          return {
            Component: mapping[BODY_TYPES.LOAN_DETAILS_CARD],
            props: {
              type: BODY_TYPES.LOAN_DETAILS_CARD,
              loanHeading: item?.attributes?.loanHeading,
              loanDescription: item?.attributes?.loanDescription,
              detailCardHeading: item?.attributes?.detailCardHeading,
              duration: item?.attributes?.duration,
              status: item?.attributes?.status,
              intrestRate: item?.attributes?.intrestRate,
              installment: item?.attributes?.installment,
              cardData: item?.attributes?.cardData,
            },
          };
        case BODY_TYPES.MEAT_BALLS_LOADER:
          return {
            Component: mapping[BODY_TYPES.MEAT_BALLS_LOADER],
            props: {
              type: BODY_TYPES.MEAT_BALLS_LOADER,
              loadingText: item.attributes.loadingText,
              style: {
                marginTop: item?.attributes?.marginTop,
              },
            },
          };
        case BODY_TYPES.ONBOARDING_CARD:
          return {
            Component: mapping[BODY_TYPES.ONBOARDING_CARD],
            props: {
              type: BODY_TYPES.ONBOARDING_CARD,
              cardBackgroundImage: item?.attributes?.cardBackgroundImage,
              cardDescription: item?.attributes?.cardDescription,
              cardHeading: item?.attributes?.cardHeading,
            },
          };
        case BODY_TYPES.LOAN_DISBURSEMENT_CARD: {
          return {
            Component: mapping[BODY_TYPES.LOAN_DISBURSEMENT_CARD],
            props: {
              type: BODY_TYPES.LOAN_DISBURSEMENT_CARD,
              cardData: item?.attributes?.cardData,
              discription: item?.attributes?.discription,
              heading: item?.attributes?.heading,
              maxValue: item?.attributes?.maxValue,
              minValue: item?.attributes?.minValue,
            },
          };
        }
        case BODY_TYPES.BANK_SELECT_CARD: {
          return {
            Component: mapping[BODY_TYPES.BANK_SELECT_CARD],
            props: {
              type: BODY_TYPES.BANK_SELECT_CARD,
              data: item?.attributes?.data,
              selectable: item?.attributes?.isradioVisible,
              withoutBorder: item?.attributes?.withoutBorder,
            },
          };
        }
        case BODY_TYPES.CUSTOM_CONNECT_CARD: {
          return {
            Component: mapping[BODY_TYPES.CUSTOM_CONNECT_CARD],
            props: {
              type: BODY_TYPES.CUSTOM_CONNECT_CARD,
              cardDescription: item?.attributes?.card_description,
              buttonText: item?.attributes?.button_text,
              connectUrl: item?.attributes?.connect_url,
            },
          };
        }
        case BODY_TYPES.CUSTOM_CONTENT_CARD: {
          return {
            Component: mapping[BODY_TYPES.CUSTOM_CONTENT_CARD],
            props: {
              type: BODY_TYPES.CUSTOM_CONTENT_CARD,
              cardType: item?.attributes?.card_type,
              cardHeading: item?.attributes?.card_heading,
              cardColor: getColor(item?.attributes?.background_color),
              cardDescription: item?.attributes?.card_description,
              cardImage: item?.attributes?.cardImage,
              buttonText: item?.attributes?.button_text,
              cardValue: item?.attributes?.card_value,
              footerText: item?.attributes?.footer_text,
              headerIcon: item?.attributes?.header_icon,
              headerText: item?.attributes?.header_text,
            },
          };
        }
        case BODY_TYPES.BULLET_CARD: {
          return {
            Component: mapping[BODY_TYPES.BULLET_CARD],
            props: {
              type: BODY_TYPES.BULLET_CARD,
              heading: item?.attributes?.heading,
              bulletPoints: item?.attributes?.card_data,
            },
          };
        }
        case BODY_TYPES.UPLOAD_CARD: {
          return {
            Component: mapping[BODY_TYPES.UPLOAD_CARD],
            props: {
              type: BODY_TYPES.UPLOAD_CARD,
              heading: item?.attributes?.heading,
              description: item?.attributes?.description,
              uploadText: item?.attributes?.upload_text,
              uploadIcon: item?.attributes?.upload_icon,
              maxFileSize: item?.attributes?.max_file_size,
              fileType: item?.attributes?.file_type,
              cardColor: getColor(item?.attributes?.background_color),
              cardImage: item?.attributes?.cardImage,
              title: item?.attributes?.title,
            },
          };
        }
        case FOOTER_TYPES.ICON_TEXT: {
          return {
            Component: mapping[FOOTER_TYPES.ICON_TEXT],
            props: {
              icon: getSvgComponent(item?.attributes?.icon),
              text: item?.attributes?.text,
              type: FOOTER_TYPES.ICON_TEXT,
              link: item?.attributes?.link,
            },
          };
        }
        case BODY_TYPES.REQUEST_ID_CARD: {
          return {
            Component: mapping[BODY_TYPES.REQUEST_ID_CARD],
            props: {
              type: BODY_TYPES.REQUEST_ID_CARD,
              title: item?.attributes?.title,
              description: item?.attributes?.description,
            },
          };
        }
        case BODY_TYPES.POWERED_BY: {
          return {
            Component: mapping[BODY_TYPES.POWERED_BY],
            props: {
              type: BODY_TYPES.POWERED_BY,
              title: item?.attributes?.title,
              footerText: item?.attributes?.footerText,
              isHidePoweredBy: item?.attributes?.isHidePoweredBy,
            },
          };
        }
        case BODY_TYPES.UPLOAD_SUCCESS_CARD: {
          return {
            Component: mapping[BODY_TYPES.UPLOAD_SUCCESS_CARD],
            props: {
              type: BODY_TYPES.UPLOAD_SUCCESS_CARD,
              title: item?.attributes?.title,
              description: item?.attributes?.description,
              documentName: item?.attributes?.document_name,
            },
          };
        }
        case BODY_TYPES.STATUS_INFO_CARD: {
          return {
            Component: mapping[BODY_TYPES.STATUS_INFO_CARD],
            props: {
              type: BODY_TYPES.STATUS_INFO_CARD,
              statusText: item?.attributes?.statusText,
              statusTime: item?.attributes?.statusTime,
              dotColor: item?.attributes?.dotColor,
            },
          };
        }
        case BODY_TYPES.CONNECT_BANK_CARD:
          return {
            Component: mapping[BODY_TYPES.CONNECT_BANK_CARD],
            props: {
              type: BODY_TYPES.CONNECT_BANK_CARD,
              heading: item?.attributes?.heading,
              description: item?.attributes?.description,
              dataRowText: item?.attributes?.dataRowText,
              cardData: item?.attributes?.cardData,
              topButtonText: item?.attributes?.topButtonText,
              buttonText: item?.attributes?.buttonText,
              showCount: item?.attributes?.showCount,
              action: item?.attributes?.action,
            },
          };
        case BODY_TYPES.COLLAPSIBLE_INFO:
          return {
            Component: mapping[BODY_TYPES.COLLAPSIBLE_INFO],
            props: {
              type: BODY_TYPES.COLLAPSIBLE_INFO,
              heading: item?.attributes?.heading,
              description: item?.attributes?.description,
              leftIcon: getSvgComponent(item?.attributes?.leftIcon),
              open: item?.attributes?.open,
            },
          };
        case BODY_TYPES.DATA_LABEL_CARD:
          return {
            Component: mapping[BODY_TYPES.DATA_LABEL_CARD],
            props: {
              type: BODY_TYPES.DATA_LABEL_CARD,
              title: item?.attributes?.heading,
              description: item?.attributes?.description,
            },
          };
        case BODY_TYPES.PING_PONG_ICONS:
          return {
            Component: mapping[BODY_TYPES.PING_PONG_ICONS],
            props: {
              type: BODY_TYPES.PING_PONG_ICONS,
            },
          };
        case BODY_TYPES.REQUIRED_DOCUMENTS_CARD:
          return {
            Component: mapping[BODY_TYPES.REQUIRED_DOCUMENTS_CARD],
            props: {
              type: BODY_TYPES.REQUIRED_DOCUMENTS_CARD,
              heading: item?.attributes?.heading,
              noteQuestion: item?.attributes?.noteQuestion,
              noteAnswer: item?.attributes?.noteAnswer,
            },
          };
        case BODY_TYPES.FILE_UPLOAD_CARD:
          return {
            Component: mapping[BODY_TYPES.FILE_UPLOAD_CARD],
            props: {
              type: BODY_TYPES.FILE_UPLOAD_CARD,
            },
          };
        case BODY_TYPES.PARTNER_LIST_CARD:
          return {
            Component: mapping[BODY_TYPES.PARTNER_LIST_CARD],
            props: {
              type: BODY_TYPES.PARTNER_LIST_CARD,
              cardData: item?.attributes?.cardData,
            },
          };
        case BODY_TYPES.CURRENT_LINKED_BANK_CARD:
          return {
            Component: mapping[BODY_TYPES.CURRENT_LINKED_BANK_CARD],
            props: {
              type: BODY_TYPES.CURRENT_LINKED_BANK_CARD,
              heading: item?.attributes?.heading,
              description: item?.attributes?.description,
              cardData: item?.attributes?.cardData,
            },
          };
        case BODY_TYPES.SELECTED_BANK_BADGE:
          return {
            Component: mapping[BODY_TYPES.SELECTED_BANK_BADGE],
            props: {
              type: BODY_TYPES.SELECTED_BANK_BADGE,
              cardData: item?.attributes?.cardData,
            },
          };
        case BODY_TYPES.PAYMENT_SCHEDULE_CARD:
          return {
            Component: mapping[BODY_TYPES.PAYMENT_SCHEDULE_CARD],
            props: {
              type: BODY_TYPES.PAYMENT_SCHEDULE_CARD,
              heading: item?.attributes?.heading,
              seeAll: item?.attributes?.seeAll,
              cardData: safeJsonParse(item?.attributes?.cardData, []),
              showPaymentPlanModal: stringToBoolean(
                item?.attributes?.showPaymentPlanModal
              ),
            },
          };
        case BODY_TYPES.DOCUMENT_UPLOAD_CARD:
          return {
            Component: mapping[BODY_TYPES.DOCUMENT_UPLOAD_CARD],
            props: {
              type: BODY_TYPES.DOCUMENT_UPLOAD_CARD,
              heading: item?.attributes?.heading,
              documents: item?.attributes?.documents,
            },
          };
        case BODY_TYPES.EXCLAMATION_ERROR_IMAGE: {
          return {
            Component: mapping[BODY_TYPES.EXCLAMATION_ERROR_IMAGE],
            props: {
              type: BODY_TYPES.EXCLAMATION_ERROR_IMAGE,
            },
          };
        }
        case BODY_TYPES.STEPPER_SECTION: {
          return {
            Component: mapping[BODY_TYPES.STEPPER_SECTION],
            props: {
              type: BODY_TYPES.STEPPER_SECTION,
              data: safeJsonParse(item?.attributes?.data, []),
              containerStyle: safeJsonParse(
                item?.attributes?.containerStyle,
                {}
              ),
              heading: item?.attributes?.heading,
            },
          };
        }
        case BODY_TYPES.SELECTABLE_ITEM_CARD: {
          return {
            Component: mapping[BODY_TYPES.SELECTABLE_ITEM_CARD],
            props: {
              type: BODY_TYPES.SELECTABLE_ITEM_CARD,
              data: item?.attributes?.data,
              selectedByDefault: stringToBoolean(
                item?.attributes?.selectedByDefault
              ),
              disableCheckBox: stringToBoolean(
                item?.attributes?.disableCheckBox
              ),
            },
          };
        }
        case BODY_TYPES.INFO_KEY_VALUE_CARD: {
          return {
            Component: mapping[BODY_TYPES.INFO_KEY_VALUE_CARD],
            props: {
              type: BODY_TYPES.INFO_KEY_VALUE_CARD,
              data: safeJsonParse(item?.attributes?.data, []),
              hasColon: stringToBoolean(item?.attributes?.hasColon),
              hasGrandTotal: stringToBoolean(item?.attributes?.hasGrandTotal),
              backgroundColor: item?.attributes?.backgroundColor,
              labelTextSize: item?.attributes?.labelTextSize,
              labelTextColor: item?.attributes?.labelTextColor,
              valueTextSize: item?.attributes?.valueTextSize,
              isDynamicLabel: stringToBoolean(item?.attributes?.isDynamicLabel),
              heading: item?.attributes?.heading,
              rightIcon: getSvgComponent(item?.attributes?.rightIcon),
              isCustomData: stringToBoolean(item?.attributes?.isCustomData),
            },
          };
        }
        case BODY_TYPES.PAYMENT_METHOD_CARD: {
          return {
            Component: mapping[BODY_TYPES.PAYMENT_METHOD_CARD],
            props: {
              type: BODY_TYPES.PAYMENT_METHOD_CARD,
              data: safeJsonParse(item?.attributes?.data, []),
            },
          };
        }
        case BODY_TYPES.REQUIRED_LIST_DOCUMENT_CARD: {
          return {
            Component: mapping[BODY_TYPES.REQUIRED_LIST_DOCUMENT_CARD],
            props: {
              type: BODY_TYPES.REQUIRED_LIST_DOCUMENT_CARD,
              documentList: item?.attributes?.documentList,
            },
          };
        }
        case BODY_TYPES.DATE_PICKER_INPUT: {
          return {
            Component: mapping[BODY_TYPES.DATE_PICKER_INPUT],
            props: {
              type: BODY_TYPES.DATE_PICKER_INPUT,
            },
          };
        }
        case BODY_TYPES.NOTICE_CARD: {
          return {
            Component: mapping[BODY_TYPES.NOTICE_CARD],
            props: {
              type: BODY_TYPES.NOTICE_CARD,
              expiryDate: item?.attributes?.expiryDate,
              isStatic: stringToBoolean(item?.attributes?.isStatic),
              backgroundColor: item?.attributes?.backgroundColor,
              icon: getSvgComponent(item?.attributes?.icon),
              heading: item?.attributes?.heading,
              description: item?.attributes?.description,
              containerStyle: safeJsonParse(
                item?.attributes?.containerStyle,
                {}
              ),
            },
          };
        }
        case BODY_TYPES.DOWNLOAD_DOCUMENT_CARD: {
          return {
            Component: mapping[BODY_TYPES.DOWNLOAD_DOCUMENT_CARD],
            props: {
              type: BODY_TYPES.DOWNLOAD_DOCUMENT_CARD,
              documents: item?.attributes?.documents,
            },
          };
        }
        case BODY_TYPES.DOCUMENT_GROUP_UPLOAD_CARD: {
          return {
            Component: mapping[BODY_TYPES.DOCUMENT_GROUP_UPLOAD_CARD],
            props: {
              type: BODY_TYPES.DOCUMENT_GROUP_UPLOAD_CARD,
              documents: safeJsonParse(item?.attributes?.documents, []),
            },
          };
        }
        case BODY_TYPES.HEADING_SKELETON: {
          return {
            Component: mapping[BODY_TYPES.HEADING_SKELETON],
            props: {
              type: BODY_TYPES.HEADING_SKELETON,
              containerStyle: safeJsonParse(
                item?.attributes?.containerStyle,
                {}
              ),
            },
          };
        }
        case BODY_TYPES.DETAIL_CARD_SKELETON: {
          return {
            Component: mapping[BODY_TYPES.DETAIL_CARD_SKELETON],
            props: {
              type: BODY_TYPES.DETAIL_CARD_SKELETON,
              containerStyle: safeJsonParse(
                item?.attributes?.containerStyle,
                {}
              ),
            },
          };
        }
        case BODY_TYPES.NOTICE_CARD_SKELETON: {
          return {
            Component: mapping[BODY_TYPES.NOTICE_CARD_SKELETON],
            props: {
              type: BODY_TYPES.NOTICE_CARD_SKELETON,
              containerStyle: safeJsonParse(
                item?.attributes?.containerStyle,
                {}
              ),
            },
          };
        }
        case BODY_TYPES.BUTTON_SKELETON: {
          return {
            Component: mapping[BODY_TYPES.BUTTON_SKELETON],
            props: {
              type: BODY_TYPES.BUTTON_SKELETON,
              containerStyle: safeJsonParse(
                item?.attributes?.containerStyle,
                {}
              ),
            },
          };
        }
        case BODY_TYPES.HOW_IT_WORKS_CARDS: {
          return {
            Component: mapping[BODY_TYPES.HOW_IT_WORKS_CARDS],
            props: {
              type: BODY_TYPES.HOW_IT_WORKS_CARDS,
              data: safeJsonParse(item?.attributes?.data, []),
            },
          };
        }
        case BODY_TYPES.AVAILABLE_ASSETS_CARD: {
          return {
            Component: mapping[BODY_TYPES.AVAILABLE_ASSETS_CARD],
            props: {
              type: BODY_TYPES.AVAILABLE_ASSETS_CARD,
              rightIcon: getSvgComponent(item?.attributes?.rightIcon),
              heading: item?.attributes?.heading,
              description: item?.attributes?.description,
              progressLabel: item?.attributes?.progressLabel,
              assetsCardHeading: item?.attributes?.assetsCardHeading,
              assets: safeJsonParse(item?.attributes?.assets, []),
              remainingLabel: item?.attributes?.remainingLabel,
              selectedAssets: safeJsonParse(
                item?.attributes?.selectedAssets,
                []
              ),
            },
          };
        }
        case BODY_TYPES.RADIO_GROUP: {
          return {
            Component: mapping[BODY_TYPES.RADIO_GROUP],
            props: {
              type: BODY_TYPES.RADIO_GROUP,
              question: item?.attributes?.question,
              options: safeJsonParse(item?.attributes?.options, []),
              key: item?.attributes?.key,
              initialValue: item?.attributes?.initialValue,
            },
          };
        }
        case BODY_TYPES.EDIT_OPTION_CARD: {
          return {
            Component: mapping[BODY_TYPES.EDIT_OPTION_CARD],
            props: {
              type: BODY_TYPES.EDIT_OPTION_CARD,
              data: safeJsonParse(item?.attributes?.data, []),
              isEditable: stringToBoolean(item?.attributes?.isEditable),
              isTranslated: stringToBoolean(item?.attributes?.isTranslated),
            },
          };
        }
        default:
          return null;
      }
    })
    .filter(Boolean);
};
